export enum CountryValidationEnum {
  'USA' = 'usaZipCode',
  'Canada' = 'caZipCode'
}
